import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const CollapseContainer = withTheme(styled(Box)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding-left: 16px;
  margin-top: 12px;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5 !important;
  }
`);
